<template>
  <BaseModal modal-id="modalAlert" :extendedModal="true" :show-modal="showMailOtpModalActive" :allow-esc="bindEscKey">
    <template #heading>Confirmation</template>
    <template #content>
      <div class="app-modal-basic">
        <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
        <div>
          <p>Resending the Login Code will invalidate the Login Code sent to you previously, including any Mail Login Code. Click YES to proceed or NO to remain on this screen.</p>
        </div>
      </div>
    </template>
    <template #footing>
      <BaseButtonGroup>
        <template #default>
          <button @click.prevent="handleSecondaryButton()">
            No
          </button>
          <button class="app-btn-primary" @click.prevent="handlePrimaryButton()">
            Yes
          </button>
        </template>
      </BaseButtonGroup>
    </template>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal'
  import BaseButtonGroup from '@/components/ui/BaseButtonGroup'

  export default {
    name: 'MailOtpConfirmationModal',
    components: {
      BaseModal,
      BaseButtonGroup,
    },
    props: {showMailOtpModalActive: Boolean},
    data() {
      return {
        bindEscKey: false,
      };
    },
    computed: {
      // ...mapState([
  
      // ])
    },
    methods: {
      handlePrimaryButton() {
        this.$emit('getMailOtpShowStatus', 'Yes')
      },
      handleSecondaryButton() {
        this.$emit('getMailOtpShowStatus', 'No')
      }
    }
  }
</script>

<style lang="scss" scoped>
// TODO: should have been picked up from @ridmv/web-themes but it's not...
.app-modal-basic {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  img {
    margin: 1em 0.5em 0 0;
    width: 1.25rem;
  }
  p {
    &:first-child {
      @extend %font-sans-bold;
      font-size: 1.25rem;
    }
    &:not(first-child) {
      @extend %font-sans-semibold;
    }
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

</style>
